import React, { useState, useEffect, useCallback, useContext } from "react";

import { useAlert } from "react-alert";
import { useDropzone } from "react-dropzone";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
//import context from "../../../../../../context/auth-context";

function Answer(props) {
  return (
    <>
      <div className="col-md-12">
        <section className="container">
          <Paper
            component="form"
            sx={{
              p: "4px 4px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
            fullWidth
            elevation={0}
          >
            <Box>
              {props.data && (
                <>
                  <Typography>Answer</Typography>
                  {props.data.answer}
                </>
              )}
            </Box>
          </Paper>
        </section>
      </div>
    </>
  );
}
export default Answer;
